<template>
  <Section :title="gettext('Quelle est votre consommation d’électricité?')">
    <div class="grid grid--large grid--multiline">
      <div class="grid__item md-w-1/2">
        <FormGroup :field="consumptionField" :errors="consumptionErrors">
          <div class="field-group">
            <Input
              v-model="tempConsumptionValue"
              inputmode="numeric"
              pattern="[0-9]*"
            />
            <div class="field-group__addon">
              kilowattheures <small class="text-muted">(kWh)</small>
            </div>
          </div>
        </FormGroup>
      </div>
    </div>
  </Section>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue';
import FormGroup from '@/components/forms/FormGroup.vue';
import Input from '@/components/forms/fields/Input.vue';
import Section from '@/components/simulation/Section.vue';
import { useSimulation } from '@/composables/useSimulation';

const consumptionErrors = ref([]);
const tempConsumptionValue = ref(null);

const { simulation, updateSimulation, consumptionField } = useSimulation();

onMounted(() => {
  tempConsumptionValue.value = simulation.consumption;
});

watch(tempConsumptionValue, (value) => {
  consumptionErrors.value = [];
  const consumption = parseInt(value);

  /* eslint-disable-next-line eqeqeq */
  if (isNaN(consumption) || consumption != value) {
    consumptionErrors.value.push(gettext('Doit être un nombre.'));
    updateSimulation({ consumption: null });
    return;
  }

  updateSimulation({
    consumption,
    power: consumption / 1500, // X kWH divided by 1500 hours
  });
});
</script>
